"use strict";
/**
 * Shared constants for portal e2e test applicants.
 * Used by both playwrightInitData.ts (backend seeder) and portalContractorDashboard.spec.ts (e2e tests).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTRACTOR_PORTAL_UNASSIGNED_REP_CLIENT = exports.CONTRACTOR_PORTAL_MANAGER_REP_CLIENT = exports.CONTRACTOR_PORTAL_USER_CHARLIE = exports.CONTRACTOR_PORTAL_USER_BOB = exports.CONTRACTOR_PORTAL_USER_ALICE = void 0;
exports.CONTRACTOR_PORTAL_USER_ALICE = { firstName: 'Alice', lastName: 'Johnson', phone: '4155550101' };
exports.CONTRACTOR_PORTAL_USER_BOB = { firstName: 'Bob', lastName: 'Smith', phone: '4155550102' };
exports.CONTRACTOR_PORTAL_USER_CHARLIE = { firstName: 'Charlie', lastName: 'Davis', phone: '4155550103' };
/** Applicant owned by the Playwright sales rep assigned to the manager. */
exports.CONTRACTOR_PORTAL_MANAGER_REP_CLIENT = { firstName: 'Rep Client', lastName: 'Alpha', phone: '4155550104' };
/** Applicant owned by a sales rep who is NOT assigned to that manager: visible only when the merchant widens visibility. */
exports.CONTRACTOR_PORTAL_UNASSIGNED_REP_CLIENT = { firstName: 'Rep Client', lastName: 'Beta', phone: '4155550105' };
